"use client";

import useWindowSize from "@/helpers/useWindowSize";
import styles from "./styles.module.scss";
import ClickToScroll from "@/components/sections/NewLists/ClickToScroll";
import { HightlightsCard } from "@molecules/HighlightsCarousel/HighlightsCarousel";

export default function VideoWithTitleCarousel({ data, id,sectionHeading="" }) {
  const { isDesktop } = useWindowSize();

  if (isDesktop) {
    return (
      <div className={`${styles.root}`} id={id}>
        <ClickToScroll id={id} />
        {data?.map((d, i) => (
          <HightlightsCard sectionHeading={sectionHeading} videoData={d} key={i} rootStyles={styles.card} />
        ))}
      </div>
    );
  }

  return (
    <div className={styles.root}>
      {data?.map((d, i) => (
        <HightlightsCard sectionHeading={sectionHeading} videoData={d} key={i} />
      ))}
    </div>
  );
}
